import { FC, SVGProps } from 'react'

export const CheckmarkIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 9.6736L8.18182 15.8125L22.0909 2"
        stroke="#000000"
        strokeWidth="2.51136"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
